export const GET_FREIGHT_GRID_REQUEST = 'GET_FREIGHT_GRID_REQUEST';
export const getFreightGridRequest = (page?: number, pageSize?: number, statusFilter?: string | null) => ({
  type: GET_FREIGHT_GRID_REQUEST,
  page,
  pageSize,
  statusFilter,
});

export const GET_FREIGHT_GRID_SUCCESS = 'GET_FREIGHT_GRID_SUCCESS';
export const getFreightGridSuccess = (currentPageShipmentIds: number[], page: number, pageSize: number, totalCount: number) => ({
  type: GET_FREIGHT_GRID_SUCCESS,
  currentPageShipmentIds,
  page,
  pageSize,
  totalCount,
});

export const GET_FREIGHT_GRID_ERROR = 'GET_FREIGHT_GRID_ERROR';
export const getFreightGridError = (error: string) => ({
  type: GET_FREIGHT_GRID_ERROR,
  error,
});

export const SET_SELECTED_FREIGHT_SHIPMENT_IDS = 'SET_SELECTED_FREIGHT_SHIPMENT_IDS';
export const setSelectedFreightShipmentIds = (selectedShipmentIds: string[]) => ({
  type: SET_SELECTED_FREIGHT_SHIPMENT_IDS,
  selectedShipmentIds,
});

export const SET_FREIGHT_GRID_FILTERS = 'SET_FREIGHT_GRID_FILTERS';
export const setFreightGridFilters = (filters: Record<string, unknown>) => ({
  type: SET_FREIGHT_GRID_FILTERS,
  filters,
});
